import React, { lazy, Suspense, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import Loader from "./components/Loader";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ScrollToTop from "./components/ScrollToTop";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { CartProvider } from "./context/CartContext";

import AOS from "aos";
import "aos/dist/aos.css";

import SuccessPage from "./pages/SuccessPage";
import FailurePage from "./pages/FailurePage";

// Lazy-loaded pages
const HomePage = lazy(() => import("./pages/HomePage"));
const ProductDetails = lazy(() => import("./pages/ProductDetails"));
const ContactPage = lazy(() => import("./pages/ContactPage"));
const AboutPage = lazy(() => import("./pages/AboutPage"));
const JoinProviderPage = lazy(() => import("./pages/JoinProviderPage"));
const ProductDetailsPage = lazy(() => import("./pages/ProductDetailsPage"));
const CartPage = lazy(() => import("./pages/CartPage"));
const CheckoutPage = lazy(() => import("./pages/CheckoutPage"));
const FaqPage = lazy(() => import("./pages/FaqPage"));
const BlogListPage = lazy(() => import("./pages/BlogListPage"));
const BlogDetailsPage = lazy(() => import("./pages/BlogDetailsPage"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const TermsAndConditions = lazy(() => import("./pages/TermsAndConditions"));
const NotFoundPage = lazy(() => import("./pages/NotFoundPage"));

const useDisableRightClickAndF5 = () => {
  useEffect(() => {
    const handleContextMenu = (e) => e.preventDefault();

    const handleKeyDown = (e) => {
      if ((e.which || e.keyCode) === 116) {
        e.preventDefault();
      }
    };

    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
};

function AppRoutes() {
  useDisableRightClickAndF5();
  const location = useLocation();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: "ease-in-out",
    });
  }, []);

  return (
    <>
      <Header />
      <main className="flex-grow-1">
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/faqs" element={<FaqPage />} />
            <Route path="/blogs" element={<BlogListPage />} />
            <Route path="/blogs/:id" element={<BlogDetailsPage />} />
            <Route path="/products" element={<ProductDetails />} />
            <Route path="/products/:id" element={<ProductDetailsPage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/join-cafe" element={<JoinProviderPage />} />

            <Route path="/success/:id" element={<SuccessPage />} />
            <Route path="/failure" element={<FailurePage />} />

            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-conditions" element={<TermsAndConditions />} />

            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    // <Router
    //   future={{
    //     v7_startTransition: true,
    //     v7_relativeSplatPath: true,
    //     v7_fetcherPersist: true,
    //     v7_normalizeFormMethod: true,
    //     v7_prependBasename: true,
    //   }}
    // >
    <Router basename="/">
      <CartProvider>
        {" "}
        <ScrollToTop />
        <AppRoutes />
        <ToastContainer position="top-right" autoClose={3000} />
      </CartProvider>
    </Router>
  );
}

export default App;
